module.exports = __webpack_public_path__ + "img/679bc4cd0fa5b31d091829b5318c187.c40bfd24.png";